import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import numbers from "core/numbers";
import useNav from "core/hooks/useNav";

import Actions from "ui/base/Actions";
import Alert from "ui/base/Alert";
import Page from "ui/Page";

import { useCards, usePay } from "features/pay/fabric";
import PaymentMethods from "features/pay/ui/PaymentMethods";

import Slider from "areas/pay/ui/Slider";
import Payment from "areas/pay/ui/Payment";


export default function Pay() {
	const pay = usePay();
	const cards = useCards();
	const theme = useTheme();
	const nav = useNav();

	const style = {
		page: {
			justifyContent: { xs: "flex-start", sm: "center" },
			gap: 2,
			p: { xs: theme.spacing(1.5, 2), sm: theme.spacing(2.5, 2) }
		},
		body: { gap: theme.spacing(2) },
		actions: { maxWidth: "380px", width: "100%", gap: 2, m: "0 auto", alignItems: "center" },
		methods: {
			background: "transparent",
			border: "2px solid #434579"
		},
		header: { alignItems: "center", textAlign: "center", "*": { alignSelf: "auto" } },
		title: { alignSelf: "center" }
	};

	const click = () => {
		pay.mutation.reset();
		pay.mutation.mutate();
	};

	const actions = [
		{ label: `Get ${numbers.format(pay.store.token?.tokens, "number")} Tokens - ${numbers.format(pay.store.token?.price, "currency")}`, variant: "contained", color: "tertiary", onClick: click, loading: pay.mutation.isPending, hide: cards.isLoading || cards.store.adding },
		{ label: "Back", variant: "outlined", onClick: () => nav.back(), disabled: pay.mutation.isPending || cards.isLoading, sx: { width: "100px" }, hide: cards.store.adding }
	];

	return (
		<Page maxWidth="dark" sx={style.page}>
			<Page.Header gap={1} sx={style.header}>
				<Typography variant="h6" color="text.primary" sx={style.title}>Get tokens</Typography>
			</Page.Header>
			<Page.Body sx={style.body}>
				<Slider />
				<Payment.Tooltip />
				<Alert.Error errors={pay.mutation.error?.errors?.[""]} />
				<Payment.Auto />
				<PaymentMethods sx={style.methods} />
				<Actions actions={actions} sx={style.actions} />
			</Page.Body>
		</Page>
	);
}